import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { FAST_API_BASE_URL } from "constants";
import { isNightShift } from "../utils/calendarUtils";

const useTeamScheduling = (domainId) => {
  const [teamSchedulingStatus, setTeamSchedulingStatus] = useState(null);
  const [teamMembers, setTeamMembers] = useState([]);
  const [isTeamSchedulingEnabled, setIsTeamSchedulingEnabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [schedulingSettings, setSchedulingSettings] = useState({
    slot_duration_minutes: 30,
    buffer_before_minutes: 5,
    buffer_after_minutes: 5,
    min_lead_time_hours: 4,
    max_booking_days: 90,
    timezone: 'UTC',
  });

  useEffect(() => {
    if (!domainId) {
      setTeamSchedulingStatus(null);
      setTeamMembers([]);
      setIsTeamSchedulingEnabled(false);
      setSchedulingSettings({
        slot_duration_minutes: 30,
        buffer_before_minutes: 5,
        buffer_after_minutes: 5,
        min_lead_time_hours: 4,
        max_booking_days: 90,
        timezone: 'UTC',
      });
    }
  }, [domainId]);

  const fetchTeamSchedulingStatus = useCallback(async () => {
    if (!domainId) return;
    
    try {
      setIsLoading(true);
      const res = await axios.get(`${FAST_API_BASE_URL}/api/team-scheduling/status`, {
        headers: { "DOMAIN-TOKEN": domainId },
      });
      
      if (res.data.success) {
        setTeamSchedulingStatus(res.data.data);
        setIsTeamSchedulingEnabled(res.data.data.can_accept_bookings);
        const members = res.data.data.team_members || [];
        const membersWithNightShift = members.map(member => ({
          ...member,
          is_night_shift: isNightShift(member.working_hours_start, member.working_hours_end)
        }));
        setTeamMembers(membersWithNightShift);
        
        if (res.data.data.config) {
          setSchedulingSettings(res.data.data.config);
        }
      } else {
        setTeamSchedulingStatus(null);
        setIsTeamSchedulingEnabled(false);
      }
    } catch (err) {
      console.error("Failed to fetch team scheduling status:", err);
      setTeamSchedulingStatus(null);
      setIsTeamSchedulingEnabled(false);
    } finally {
      setIsLoading(false);
    }
  }, [domainId]);

  return {
    teamSchedulingStatus,
    teamMembers,
    isTeamSchedulingEnabled,
    setIsTeamSchedulingEnabled,
    schedulingSettings,
    setSchedulingSettings,
    fetchTeamSchedulingStatus,
    setTeamSchedulingStatus,
    setTeamMembers,
    isLoading
  };
};

export default useTeamScheduling;